import type { LensTheme } from '@diligentcorp/atlas-theme-mui-lens';
import { Box, Checkbox, FormControlLabel, useTheme } from '@mui/material';
import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { SectionHeader } from '../../molecules/SectionHeader/SectionHeader';
import type { FormValues } from '../../organisms/AddRuleDrawer/useAddRuleDrawer';

interface Props {
  control: Control<FormValues>;
}

export const ManualReviewSection: React.FC<Props> = ({ control }) => {
  const theme = useTheme<LensTheme>();

  const sp = theme.tokens.semantic.spacing.desktop.gap;
  const color = theme.tokens.semantic.color;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: sp[3].value,
        paddingTop: sp[4].value,
        borderTop: `1px solid ${color.ui.divider.default.value}`,
      }}
    >
      <SectionHeader
        title="Manual review"
        subtitle="Flag cases matching this rule for manual review before any actions are applied"
      />
      <Controller
        name="addToManualReview"
        control={control}
        render={({ field }) => (
          <FormControlLabel
            control={
              <Checkbox
                checked={field.value}
                onChange={(e) => field.onChange(e.target.checked)}
              />
            }
            label="Add to manual review"
          />
        )}
      />
    </Box>
  );
};
